<div *ngIf="formGroup && control && formControlName">
    <h3 *ngIf="header">{{ header }}</h3>
    <h4 *ngIf="label">
        {{ label }}{{ control.hasError("required") ? " *" : "" }}
    </h4>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
        <div
            fxFlex="100"
            fxLayoutAlign="start center"
            fxFlex.xs="100"
            fxFlexFill
        >
            <span class="radio-checkbox-group" fxFlex="100">
                <ul>
                    <li *ngFor="let selection of selections">
                        <mat-checkbox
                            *ngIf="control"
                            [value]="selection.selectionId.toString()"
                            [checked]="
                                control.value?.includes(selection.selectionId)
                            "
                            color="primary"
                            (change)="updateCheckboxGroup($event)"
                        >
                            <span class="wrap-mat-radio-checkbox-label">{{
                                selection.label
                            }}</span>
                        </mat-checkbox>
                    </li>
                </ul>
                <mat-error
                    *ngIf="
                        ((control && control.touched) || formSubmitted) &&
                        control?.hasError('required')
                    "
                    >{{ requiredMessage }}
                </mat-error>
            </span>
        </div>
    </div>
</div>
